import { Auth } from 'aws-amplify';
import { useCallback, useState } from 'react';

const useResendSignUp = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();

  const resendSignup = useCallback(async (email, { onSuccess, onError }) => {
    setIsLoading(true);
    setError(undefined);

    try {
      await Auth.resendSignUp(email);
      setIsLoading(false);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      setError(err);
      setIsLoading(false);
      if (onError) {
        onError(err);
      }
    }
  }, []);

  return { isLoading, error, resendSignup };
};

export default useResendSignUp;
